/**
 * Sums the MWh of `items` per key, in first-seen key order; callers sort and label the groups.
 */
export function groupMwh<T>(
  items: readonly T[],
  keyOf: (item: T) => string,
  mwhOf: (item: T) => number
): Map<string, number> {
  const groups = new Map<string, number>();
  for (const item of items) {
    const key = keyOf(item);
    groups.set(key, (groups.get(key) ?? 0) + mwhOf(item));
  }
  return groups;
}
